import moment from "moment";
import "moment/locale/it";
export default function(){
    this.main.lessThenToday = function lessThenToday(cb){
        console.log("LessThanToday");
        if(this.validates()){
            if(this.value){
                let today = moment().startOf("day");
                let date = moment.utc(this.value, [this.rule.format], true);
                if(date.isValid()){
                    if(date.local().isAfter(today)){
                        this.raise("Il campo %s deve avere una data antecedente ad oggi");
                    }
                } else {
                    this.raise("La data inserita non è valida");
                }
            }
        }
        cb();
    },
        this.main.LessThanOrEqualToday = function LessThanOrEqualToday(cb) {
            console.log("LessThanOrEqualToday");
        if (this.validates()) {
            if (this.value) {
                let today = moment().startOf("day").add(1, 'd');
                let date = moment.utc(this.value, [this.rule.format], true);
                if (date.isValid()) {
                    if (date.local().isAfter(today)) {
                        this.raise("Il campo %s deve avere una data antecedente ad oggi");
                    }
                } else {
                    this.raise("La data inserita non è valida");
                }
            }
        }
        cb();
    };
}
